import { useNavigate } from 'react-router';
import { useMutation } from '@tanstack/react-query';
import * as R from 'Router/routes';
import { fetchData } from 'utils';
import { useStore } from 'hooks/useStore';
import useSmartlook from 'hooks/useSmartlook';

export default function useBankIDAccountConfirmMutation() {
  const navigate = useNavigate();
  const { error } = useSmartlook();
  const [storeBankId, setStoreBankId] = useStore((store) => store.bankId);
  return useMutation<
    void,
    unknown,
    { uuid: string; bankAccountNumber: string }
  >({
    mutationFn: async ({ uuid, bankAccountNumber }) => {
      try {
        return await fetchData(
          `/client/bankid/sessions/${uuid}/confirm/account`,
          {
            method: 'POST',
            body: JSON.stringify({ bankAccountNumber }),
          },
        );
      } catch (e) {
        error(
          '[useBankIDAccountConfirmMutation][POST /client/bankid/sessions/{uuid}/confirm/account]',
          e,
        );
        setStoreBankId({
          bankId: {
            ...storeBankId,
            error: true,
          },
        });
        navigate(R.BANK_ID_ERROR);
        return undefined;
      }
    },
  });
}
